'use strict';

document.addEventListener("turbo:load", () => {
  const burger = document.getElementById('hamburger');
  
  if(burger){
    burger.addEventListener('click', () => {
      document.querySelector('.navigation').classList.toggle('active');
      burger.classList.toggle('is-active');
    });
  }
});
